/* eslint-disable jsx-a11y/no-onchange */

import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import fieldStyle from '../fields.module.scss';

const LevelDropdown = ({
  level,
  values,
  handleAnswerChanged,
  disabled,
  isRequired,
  answer,
  showFieldErrors,
  errors,
  forFormModule,
  levels,
  global_location,
  defaultValue,
  user_departments,
  multifield
}) => {
  useEffect(() => {
    const levelCheck = forFormModule? 'level_0' : 'level_1';
    if (values.length === 1 && level !== levelCheck) {
      handleAnswerChanged(level, values?.[0]?.title, level);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answer?.[level]?.title, level, values.length, values?.[0]]);

   // This useEffect using For displaying the default Global Location
   useEffect(() => {
    if (defaultValue && !answer?.[level]) {
      handleAnswerChanged(level, defaultValue, level);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleAnswerChanged, defaultValue, level]);

  // seperating favourite and not-favourite options from values prop -- **
  let favoptions = values?.filter(val => val.favourite === true && val.id !== undefined);
  let notfav = values?.filter(val => val.favourite !== true && val.id !== undefined);
  let valueOptions = (favoptions.length !== 0 && notfav.length !== 0)
  ? [...favoptions,
    // here we added underline for seperating favourite and not-favourite options in Select drop down
    { title: ' ',
      id: 'underline',
      key: 'underline'
    }, ...notfav]
    : [...favoptions, ...notfav];
  return (
  <div className={fieldStyle.multiLoc}>
    <span className={fieldStyle.levelTitle} style={multifield && { marginTop: 0 }}>
      {isRequired && <small style={{ color: 'red' }}> * </small>}
      <FormattedMessage id={levels?.[level]?.title || level} defaultMessage={levels?.[level]?.title || level} />
    </span>
    <Select
      value={answer?.[level] === undefined ? {} : { value: answer?.[level], label: answer?.[level] }}
      className={fieldStyle.multiSelect}
      onChange={e => handleAnswerChanged(level, e?.value, level)}
      name={`select-field-${level}`}
      style={{ width: (!global_location || user_departments) ? '180px' : '261px' }}
      title={answer?.[level] || ''}
      // styles prop used to add underline between favourite and not-favourite options
      styles={{
        menuPortal: base => ({ ...base, zIndex: 99999 }),
        option: (base, title) => ({
          ...base,
          borderTop: title.data.key === 'underline' ? '1px solid #8C9EA7' : 'none',
          padding: title.data.key === 'underline' ? '0' : base.padding
        })
      }}
      options={valueOptions.map((location) => {
        let displayValue = '';
        if (level === 'level_1') {
            if (location?.location_code) {
                displayValue = `${location.location_code} - ${location.title}`;
            } else {
                displayValue = location?.title || '';
            }
        } else {
            displayValue = location?.title || location?.name || '';
        }
        return {
          key: location?.id,
          value: displayValue,
          label: displayValue?.length > 30 ? `${displayValue.substring(0, 30)}...` : displayValue,
          isDisabled: location?.id === 'underline'
        };
      })}
      isDisabled={disabled}
      menuPortalTarget={document.body}
    />
    {showFieldErrors && !answer?.[level]
      && errors.map(e => (
        <small key={e}>
          <FormattedMessage
            id={e}
            defaultMessage="There is an error in this field"
          />
        </small>
      ))}
  </div>
);
};

class MultiLevel extends Component {
  constructor(props) {
    super(props);
    const { isRequired, updateFieldErrors, answer, global_location, user_departments } = this.props;
    if (
      isRequired
      && !answer
    ) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    if (global_location && !user_departments && !answer) {
      this.handleAnswerChanged('level_0', global_location?.name, 'level_0');
    }
  }

  handleAnswerChanged = (level, value, levelTitle) => {
    const {
      handleValueChange,
      handleFieldErrorChanged,
      isRequired,
      updateFieldErrors,
      answer,
      fieldId,
      global_location,
      values,
      forFormModule
    } = this.props;
    const updatedErrors = ['pulpoforms.errors.not_blank'];
    if (level === 'level_0') {
      handleValueChange({ [levelTitle]: value }, fieldId);

      let levelOneValues = values.filter(
          levelOnevalue => (levelOnevalue?.name === value)
        );
        if (levelOneValues.length > 0) {
          if (forFormModule) {
            levelOneValues = typeof levelOneValues?.slice(-1)?.[0].level_1 === 'object'
            ?Object.values(levelOneValues?.slice(-1)?.[0].level_1).filter(val => val):[];
          } else {
            levelOneValues = levelOneValues?.slice(-1)?.[0].location_levels;
          }
        }

      if (levelOneValues?.length === 0) {
        if (value !== '') handleFieldErrorChanged(fieldId, false);
        else handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) updateFieldErrors(updatedErrors);
      } else {
        handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) updateFieldErrors(updatedErrors);
      }
    } else if (level === 'level_1') {
      let assignees = [];

      let levelOneValues = values.filter(
        val => (val?.name === answer?.level_0)
      );

      const checkIsAssignmentMode = (Array.isArray(values)
          && values?.find(eachDs => eachDs.id === global_location?.key)?.info?.assignmentMode);


      if (checkIsAssignmentMode) {
        assignees = (levelOneValues?.[0]?.location_levels || []).filter(val => val?.title === value);
      }

      handleValueChange({ ...answer,
         ...answer,
          [levelTitle]: value,
          level_2: '',
         ...(checkIsAssignmentMode && assignees?.[0]?.level_1?.length>0 && { assignees: assignees?.[0]?.level_1 || [] }) }, fieldId);


      if (levelOneValues.length > 0) {
        if (forFormModule) {
          levelOneValues = typeof levelOneValues?.slice(-1)?.[0].level_1 === 'object'
        ?Object.values(levelOneValues?.slice(-1)?.[0].level_1).filter(val => val):[];
        } else {
          levelOneValues = levelOneValues?.slice(-1)?.[0].location_levels;
        }
      }

      let levelTwoValues = [];
      if (answer?.level_0 && value && levelOneValues?.length > 0
        && !(checkIsAssignmentMode)) {
        levelTwoValues = levelOneValues.filter(
          val => (val?.title === value)
        );
        if (levelTwoValues.length > 0) {
          if (forFormModule) {
            levelTwoValues = typeof levelTwoValues[0].level_2 === 'object'
            ?Object.values(levelTwoValues[0].level_2):[];
          } else {
            levelTwoValues = levelTwoValues[0].level_1;
          }
        }
      }
      if (levelTwoValues?.length === 0) {
        if (value !== '') handleFieldErrorChanged(fieldId, false);
        else handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) updateFieldErrors(updatedErrors);
      } else {
        handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) updateFieldErrors(updatedErrors);
      }
    } else if (level === 'level_2') {
      handleValueChange({ ...answer, [levelTitle]: value, level_3: '' }, fieldId);

      let levelOneValues = values.filter(
        val => (val?.name === answer?.level_0)
      );
      if (levelOneValues.length > 0) {
        if (forFormModule) {
          levelOneValues = typeof levelOneValues?.slice(-1)?.[0].level_1 === 'object'
        ?Object.values(levelOneValues?.slice(-1)?.[0].level_1).filter(val => val):[];
        } else {
          levelOneValues = levelOneValues?.slice(-1)?.[0].location_levels;
        }
      }

      let levelTwoValues = [];
      if (answer?.level_0 && answer?.level_1 && levelOneValues?.length > 0) {
        levelTwoValues = levelOneValues.filter(
          val => (val.location_code ? `${val.location_code}-${val?.title}`:val?.title === answer?.level_1)
        );
        if (levelTwoValues.length > 0) {
          if (forFormModule) {
            levelTwoValues = typeof levelTwoValues[0].level_2 === 'object'
          ?Object.values(levelTwoValues[0].level_2):[];
          } else {
            levelTwoValues = levelTwoValues[0].level_1;
          }
        }
      }

      let levelThreeValues = levelTwoValues.filter(
        levelThreeValue => (levelThreeValue?.title === value)
      );
      if (levelThreeValues.length > 0) levelThreeValues = levelThreeValues[0]?.level_2 || [];


      if (levelThreeValues?.length === 0) {
        if (value !== '') handleFieldErrorChanged(fieldId, false);
        else handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) updateFieldErrors(updatedErrors);
      } else {
        handleFieldErrorChanged(fieldId, isRequired);
        if (isRequired) updateFieldErrors(updatedErrors);
      }
    } else {
      handleValueChange({ ...answer, [levelTitle]: value }, fieldId);
      if (value !== '') handleFieldErrorChanged(fieldId, false);
        else handleFieldErrorChanged(fieldId, isRequired);
      if (isRequired) updateFieldErrors(updatedErrors);
    }
  }

  render() {
    const {
      answer,
      values,
      defaultOption,
      disabled,
      isRequired,
      showFieldErrors,
      errors,
      fieldId,
      levels,
      global_location,
      user_departments,
      title,
      dataSourceValues,
      forFormModule,
      multifield
    } = this.props;

    // debugger;
    // **Hint */ at options 3. answer is level_2 for multi_level values, for datasource option 3 is level_3.
    let fieldWidget;
    let levelOneValues = [];
    if (answer?.level_0) {
      levelOneValues = values.filter(
        value => (value?.name === answer?.level_0)
      );
      if (levelOneValues.length > 0) {
        if (forFormModule) {
          levelOneValues = typeof levelOneValues?.slice(-1)?.[0].level_1 === 'object'
        ?Object.values(levelOneValues?.slice(-1)?.[0].level_1):[];
        } else {
          levelOneValues = levelOneValues?.slice(-1)?.[0].location_levels;
        }
      }
    }
    let levelTwoValues = [];
    if (answer?.level_0 && answer?.level_1 && levelOneValues?.length > 0) {
      levelTwoValues = levelOneValues.filter(
        (value) => {
          let checkVal = answer?.level_1;
          if (value.location_code) {
            checkVal = answer?.level_1.split(`${value.location_code} - `)[1];
          }
          return value?.title === checkVal;
        }
      );
      if (levelTwoValues.length > 0) {
        if (forFormModule) {
          levelTwoValues = typeof levelTwoValues[0].level_2 === 'object'
        ?Object.values(levelTwoValues[0].level_2):[];
        } else {
          levelTwoValues = levelTwoValues[0].level_1;
        }
      }
    }
    let levelThreeValues = [];
    if (answer?.level_0 && answer?.level_1 && answer?.level_2 && levelTwoValues?.length > 0) {
      levelThreeValues = levelTwoValues.filter(
        value => (value?.title === answer?.level_2)
      );
      if (levelThreeValues.length > 0) levelThreeValues = levelThreeValues[0].level_2;
    }
    fieldWidget = (
        <select
          value={answer?.level_0}
          onChange={e => this.handleAnswerChanged('level_0', e.target.value, 'level_0')}
          name={`select-field-${fieldId}`}
          className="pulpo-dropdown"
          disabled={disabled}
          style={{ width: (answer?.level_0 && levelOneValues?.length > 0) ? '225px' : '280px' }}
        >
          <option key="default" value="">
            {defaultOption}
          </option>
          {values.map(option => (
            <option key={option.id} value={option.name}>
              {option.name}
            </option>
          ))}
        </select>
    );
    return (
      <>
        {(!global_location || user_departments) && (
        <div className={fieldStyle.multiLoc} style={!multifield && answer?.level_0 && answer?.level_0?.length>0 ? { marginTop: '20px' }:{}}>
            <span className={fieldStyle.title}>
              {isRequired && <small style={{ color: 'red' }}> * </small>}
              <FormattedMessage id={title} defaultMessage={title} />
            </span>
            {fieldWidget}
            {showFieldErrors && !answer?.level_0
          && errors.map(e => (
            <small key={e}>
              <FormattedMessage
                id={e}
                defaultMessage="There is an error in this field"
              />
            </small>
          ))}
        </div>
        )}
        {answer?.level_0 && levelOneValues?.length > 0 && (
          <LevelDropdown
            level="level_1"
            values={levelOneValues}
            defaultValue={global_location?.default_location_value?.name}
            handleAnswerChanged={this.handleAnswerChanged}
            disabled={disabled}
            forFormModule
            isRequired={isRequired}
            answer={answer}
            defaultOption={defaultOption}
            showFieldErrors={showFieldErrors}
            errors={errors}
            levels={levels}
            global_location={global_location}
            user_departments={user_departments}
            multifield={multifield}
          />
        )}
        {!(Array.isArray(dataSourceValues) && dataSourceValues?.find(eachDs => eachDs?.id === global_location?.key)?.info?.assignmentMode)
         && answer?.level_1 && levelTwoValues?.length > 0 && (
            <LevelDropdown
              level="level_2"
              values={levelTwoValues}
              handleAnswerChanged={this.handleAnswerChanged}
              disabled={disabled}
              isRequired={isRequired}
              answer={answer}
              defaultOption={defaultOption}
              showFieldErrors={showFieldErrors}
              errors={errors}
              levels={levels}
              global_location={global_location}
              user_departments={user_departments}
              multifield={multifield}
            />
        )}
        {answer?.level_2 && levelThreeValues?.length > 0 && (
            <LevelDropdown
              level="level_3"
              values={levelThreeValues}
              handleAnswerChanged={this.handleAnswerChanged}
              disabled={disabled}
              isRequired={isRequired}
              answer={answer}
              defaultOption={defaultOption}
              showFieldErrors={showFieldErrors}
              errors={errors}
              levels={levels}
              global_location={global_location}
              user_departments={user_departments}
              multifield={multifield}
            />
        )}
      </>
    );
  }
}

MultiLevel.defaultProps = {
  widget: { type: 'dropdown' },
  answer: '',
  defaultOption: ''
};

MultiLevel.propTypes = {
  widget: PropTypes.shape({ type: PropTypes.string }),
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  defaultOption: PropTypes.string
};

export default MultiLevel;
